import { isFunction } from 'lodash'
import * as React from 'react'
import Spinner from '@src/components/common/loader'
import type { RegistredFeatureflag } from '@src/endpoints/feature.flag'
import { useFeatureFlagsContext } from '../context'
import type { FeatureFlag, FeatureFlagData } from '../models'

export interface Props<T> {
  flag: RegistredFeatureflag
  component?: React.ComponentType<FeatureFlagData & T> | React.ReactNode
  children?: ((props: FeatureFlagData & T) => React.ReactNode) | React.ReactNode
  ownProps?: T
  spinnerClassName?: string
  hideSpinner?: boolean
}

function WaitFeatureFlagContext<T>(props: React.PropsWithChildren<Props<T>>) {
  const {
    children,
    flag,
    component,
    ownProps,
    spinnerClassName,
    hideSpinner = false
  } = props

  const contextFFlags = useFeatureFlagsContext()
  const fFlag: FeatureFlag = (contextFFlags || {})[flag] || {}

  function renderBody() {
    return component
      ? React.createElement(component as React.ComponentType<FeatureFlag & T>, {
          ...fFlag,
          ...ownProps
        })
      : children
      ? isFunction(children)
        ? (children as (props: FeatureFlag & T) => React.ReactNode)({
            ...fFlag,
            ...ownProps
          })
        : children
      : null
  }
  return (
    <>
      {!fFlag?.pending ? (
        renderBody()
      ) : hideSpinner ? (
        <></>
      ) : (
        <Spinner className={spinnerClassName} loading={fFlag?.pending} />
      )}
    </>
  )
}

WaitFeatureFlagContext.defaultProps = {}

export default React.memo(WaitFeatureFlagContext)
